<template>
  <div class="section-wrapper">
    <section
      class="portfolio-section"
      id="portfolio"
      aria-label="Portfolio section"
    >
      <div class="background-elements">
        <div class="grid-overlay"></div>
      </div>

      <div class="content-container">
        <div class="section-header">
          <div class="brand-tag slide-in" data-delay="100">
            <div class="tag-dot"></div>
            <span>Our Projects</span>
          </div>

          <h2 class="main-heading">
            <div class="heading-line fade-in" data-delay="300">Selected</div>
            <div class="heading-highlight fade-in" data-delay="500">
              Case Studies
              <svg
                class="heading-accent"
                viewBox="0 0 100 100"
                width="80"
                height="80"
              >
                <circle cx="50" cy="50" r="40" class="accent-circle" />
              </svg>
            </div>
          </h2>
        </div>

        <div class="portfolio-grid">
          <a
            v-for="(project, index) in projects"
            :key="index"
            :href="project.isContactCard ? '#contact' : project.link"
            class="project-card fade-in"
            :class="{ 'contact-card': project.isContactCard }"
            :data-delay="600 + index * 100"
            :target="project.isContactCard ? '_self' : '_blank'"
          >
            <div v-if="!project.isContactCard" class="project-content">
              <div class="project-image">
                <img :src="project.image" :alt="project.title" />
                <div class="image-overlay"></div>
                <div class="glow-effect"></div>
              </div>
              <div class="project-info">
                <div class="category-badge">
                  <span class="project-category">{{ project.category }}</span>
                </div>
                <h3 class="project-title">{{ project.title }}</h3>
                <p class="project-description">{{ project.description }}</p>
                <div class="project-cta">
                  <div class="cta-text">
                    <span>View Project</span>
                    <div class="cta-underline"></div>
                  </div>
                  <div class="arrow-container">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="arrow-icon"
                    >
                      <path
                        d="M7 17L17 7M17 7H7M17 7V17"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="card-border"></div>
              <div class="floating-elements">
                <div class="float-dot dot-1"></div>
                <div class="float-dot dot-2"></div>
                <div class="float-dot dot-3"></div>
              </div>
            </div>
            <div v-else class="contact-content">
              <div class="contact-bg-effect"></div>
              <div class="contact-text">
                <div class="contact-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <h3>Start Your Project</h3>
                <p>Let's create something extraordinary together</p>
                <div class="contact-cta">
                  <div class="cta-text">
                    <span>Get in Touch</span>
                    <div class="cta-underline"></div>
                  </div>
                  <div class="arrow-container">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      class="arrow-icon"
                    >
                      <path
                        d="M7 17L17 7M17 7H7M17 7V17"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "PortfolioSection",
  data() {
    return {
      projects: [
        {
          title: "Interior Doors",
          description:
            "Web store creation, CMS systems, custom solutions, door constructor",
          image: "https://i.ibb.co/jZkvTw4s/5.jpg",
          link: "https://interiordoorsco.com/",
          category: "Store",
        },
        {
          title: "My Children Bark",
          description:
            "Pet walking service with real-time tracking and booking system",
          image: "https://i.ibb.co/Y47tPnWN/1.jpg",
          link: "https://www.mychildrenbark.com",
          category: "WebApp",
        },
        {
          title: "Your Cars LLC",
          description: "Comprehensive admin panel for vehicle management",
          image: "https://i.ibb.co/zW8ngKRD/3.png",
          link: "https://yourcarllc.com/",
          category: "Shop",
        },
        {
          title: "Car Management System",
          description:
            "Complete vehicle inventory and dealership management platform with analytics and reporting",
          image: "https://i.ibb.co/fdqb5MGJ/13.webp",
          link: "#",
          category: "WebApp",
        },
        {
          title: "X DIGIT",
          description:
            "Fixed and improved the website after previous developers to ensure proper functionality.",
          image: "https://i.ibb.co/xKSQSGhc/6.png",
          link: "https://www.xdigit.us/",
          category: "Corporate site",
        },
        {
          title: "Weststar Relocation INC",
          description:
            "Licensed and insured moving professionals website with quote system and service booking functionality",
          image: "https://i.ibb.co/JjGm9v2m/12.webp",
          link: "https://weststarrelocationinc.com/",
          category: "Corporate site",
        },
        {
          title: "Verde Cars",
          description:
            "Premium car brokerage platform connecting clients with luxury vehicles in Los Angeles",
          image: "https://i.ibb.co/ym7sMjTs/14.webp",
          link: "https://www.verdecars.com/",
          category: "Corporate site",
        },
        {
          isContactCard: true,
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.section-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  position: relative;
  overflow: hidden;
  padding: 2rem 0;
}

.portfolio-section {
  --primary-color: #6366f1;
  --accent-color: #818cf8;
  --text-primary: #ffffff;
  --text-secondary: #e2e8f0;

  width: 100%;
  padding: 4rem 0;
}

.background-elements {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.grid-overlay {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(#3d73ff08 1px, transparent 1px),
    linear-gradient(90deg, #3d73ff08 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: radial-gradient(circle at 50% 50%, black, transparent 80%);
}

.content-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
}

.section-header {
  margin-bottom: 4rem;
}

.brand-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: rgba(99, 102, 241, 0.1);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 100px;
  margin-bottom: 1.5rem;

  .tag-dot {
    width: 8px;
    height: 8px;
    background: var(--accent-color);
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  span {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--text-primary);
    letter-spacing: 0.05em;
  }
}

.main-heading {
  .heading-line {
    font-size: 1.5rem;
    color: var(--text-secondary);
    margin-bottom: 0.5rem;
  }

  .heading-highlight {
    position: relative;
    font-size: 3rem;
    font-weight: 700;
    color: var(--text-primary);

    .heading-accent {
      position: absolute;
      top: -20px;
      right: -40px;
      z-index: -1;

      .accent-circle {
        fill: none;
        stroke: var(--accent-color);
        stroke-width: 2;
        stroke-dasharray: 251;
        stroke-dashoffset: 251;
        animation: drawCircle 2s ease forwards;
      }
    }
  }
}

.portfolio-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.project-card {
  aspect-ratio: 16/9;
  text-decoration: none;
  color: inherit;
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  transform-style: preserve-3d;
  perspective: 1000px;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(99, 102, 241, 0.1),
      rgba(129, 140, 248, 0.05)
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: 1;
  }

  &:hover {
    transform: translateY(-12px) rotateX(5deg);

    &::before {
      opacity: 1;
    }

    .glow-effect {
      opacity: 0.6;
      transform: scale(1.1);
    }

    .card-border {
      opacity: 1;
      transform: scale(1.02);
    }

    .floating-elements .float-dot {
      animation-play-state: running;
    }

    .project-image img {
      transform: scale(1.08);
    }

    .image-overlay {
      opacity: 0.9;
    }

    .arrow-container {
      transform: translate(8px, -8px) rotate(45deg);
    }

    .cta-underline {
      width: 100%;
    }

    .category-badge {
      transform: translateY(-4px);
    }
  }
}

.project-content {
  position: relative;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(15, 15, 15, 0.95),
    rgba(30, 30, 30, 0.9)
  );
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  overflow: hidden;
}

.project-image {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  }
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0.7) 40%,
    rgba(0, 0, 0, 0.3) 70%,
    rgba(0, 0, 0, 0) 100%
  );
  opacity: 0.8;
  transition: opacity 0.4s ease;
  z-index: 2;
}

.glow-effect {
  position: absolute;
  inset: -20px;
  background: radial-gradient(
    circle at 30% 70%,
    rgba(99, 102, 241, 0.3),
    rgba(129, 140, 248, 0.2),
    transparent 70%
  );
  opacity: 0;
  transition: all 0.6s ease;
  z-index: 0;
}

.card-border {
  position: absolute;
  inset: 0;
  border: 2px solid transparent;
  border-radius: 24px;
  background: linear-gradient(
      135deg,
      rgba(99, 102, 241, 0.5),
      rgba(129, 140, 248, 0.3)
    )
    border-box;
  mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  mask-composite: xor;
  opacity: 0;
  transition: all 0.4s ease;
  z-index: 3;
}

.floating-elements {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
}

.float-dot {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(99, 102, 241, 0.6);
  border-radius: 50%;
  animation: float 3s ease-in-out infinite;
  animation-play-state: paused;

  &.dot-1 {
    top: 20%;
    left: 85%;
    animation-delay: 0s;
  }

  &.dot-2 {
    top: 70%;
    left: 90%;
    animation-delay: 1s;
    background: rgba(129, 140, 248, 0.6);
  }

  &.dot-3 {
    top: 45%;
    left: 88%;
    animation-delay: 2s;
    background: rgba(168, 85, 247, 0.6);
  }
}

.project-info {
  position: absolute;
  inset: 0;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 4;
}

.category-badge {
  display: inline-block;
  margin-bottom: 1rem;
  transition: transform 0.3s ease;
}

.project-category {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--accent-color);
  background: rgba(99, 102, 241, 0.15);
  padding: 0.4rem 0.8rem;
  border-radius: 20px;
  border: 1px solid rgba(99, 102, 241, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.project-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.75rem;
  line-height: 1.2;
  background: linear-gradient(135deg, #ffffff, #e2e8f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.project-description {
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 0 0 2rem;
  line-height: 1.6;
  opacity: 0.9;
}

.project-cta,
.contact-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: var(--text-primary);
}

.cta-text {
  position: relative;

  span {
    font-size: 1.1rem;
  }
}

.cta-underline {
  position: absolute;
  bottom: -4px;
  left: 0;
  height: 2px;
  width: 0;
  background: linear-gradient(90deg, var(--primary-color), var(--accent-color));
  transition: width 0.4s ease;
}

.arrow-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(99, 102, 241, 0.2);
  border: 1px solid rgba(99, 102, 241, 0.3);
  border-radius: 50%;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);

  .arrow-icon {
    transition: transform 0.3s ease;
  }
}

.contact-card {
  background: linear-gradient(
    135deg,
    rgba(99, 102, 241, 0.15),
    rgba(129, 140, 248, 0.1)
  );
  border: 1px solid rgba(99, 102, 241, 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(99, 102, 241, 0.1),
      rgba(129, 140, 248, 0.05)
    );
    opacity: 0;
    transition: opacity 0.4s ease;
  }

  &:hover::before {
    opacity: 1;
  }
}

.contact-content {
  height: 100%;
  padding: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  z-index: 2;
}

.contact-bg-effect {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 50% 50%,
    rgba(99, 102, 241, 0.1),
    rgba(129, 140, 248, 0.05),
    transparent 70%
  );
  opacity: 0;
  transition: opacity 0.4s ease;
}

.contact-card:hover .contact-bg-effect {
  opacity: 1;
}

.contact-icon {
  margin-bottom: 1.5rem;
  color: var(--accent-color);
  animation: pulse 2s infinite;
}

.contact-text {
  h3 {
    font-size: 2rem;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 1rem;
    background: linear-gradient(135deg, #ffffff, #e2e8f0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  p {
    font-size: 1.125rem;
    color: var(--text-secondary);
    margin: 0 0 2.5rem;
    opacity: 0.9;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes drawCircle {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-10px) rotate(180deg);
    opacity: 1;
  }
}

.fade-in {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s cubic-bezier(0.22, 1, 0.36, 1);

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-in {
  opacity: 0;
  transform: translateX(-20px);
  transition: all 0.6s cubic-bezier(0.22, 1, 0.36, 1);

  &.visible {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 1024px) {
  .portfolio-grid {
    grid-template-columns: 1fr;
  }

  .project-info {
    padding: 2rem;
  }

  .project-title {
    font-size: 1.5rem;
  }
}

@media (max-width: 768px) {
  .content-container {
    padding: 0 1.5rem;
  }

  .main-heading .heading-highlight {
    font-size: 2.5rem;
  }

  .project-info {
    padding: 1.5rem;
  }

  .project-title {
    font-size: 1.25rem;
  }

  .project-description {
    font-size: 0.875rem;
  }

  .section-wrapper {
    padding: 1rem 0;
  }

  .project-card:hover {
    transform: translateY(-8px);
  }
}
</style>
